import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import Logo from "../../assets/assets/Nibss-Logo.png";
import Button3 from "../../components/Button/Button3";
import Button4 from "../../components/Button/Button4";
import { getCertPaymentDetails } from "../../redux/Actions/TestCardActions";
import { PropTypes } from "prop-types";
const Payment = (props) => {
  const [paymentType, setPaymentType] = useState("cpay-card-payment")
  const { isGetting, getDetails, details, certificationAmount } = props;


  const appId = props.location.state && props.location.state.id;
  const type = props.location.state && props.location.state.type;
  const amountId = props.location.state && props.location.state.amount_id;

  

  const history = useHistory()

  useEffect(
    () => {


      const setAmount = () => {
        const payload = {
          application_id: appId,
          product_description: type,
          payment_type: paymentType,
         amount_id: amountId,
        };

        getDetails(payload);
     
      }

      setAmount()

    },

    // eslint-disable-next-line
    [appId, type, getDetails, certificationAmount]
  );


  const validate = details && Object.keys(details).length === 0;
  const merchantId = details && details.merchant_id;
  const secretKey = details && details.secret_key;
  const productId = details && details.product_id;
  const productDesc = details && details.product_description;
  const amount = details && details.amount;
  const formattedAmount = Number(amount) / 100;
  const currency = details && details.currency;
  const transactionId = details && details.transaction_id;
  const responseUrl = details && details.response_url;
  const hash = details && details.hash;

  const paymentUrl = details && details.payment_url;



  function addCommas(x) {
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }


  const handlePaymentWithBankTransfer = () => {
    setPaymentType("cpay-transfer-payment")
    history.push({
      pathname: "/payment-with-bank-transfer",
      state: {
        formattedAmount,
        isGetting,
        paymentType,
        transactionId,
        productId
      }

    })
  }

  return (
    <div className="application">
      <Link to="/">
        {" "}
        <div className="application-logo">
          <img src={Logo} alt="Nibss" />
        </div>
      </Link>
      <div className="payment-device">
        <h1>Purchasing Certification...</h1>
        <p>
          Congratulations! You are one step closer to completing <br /> your
          payment
        </p>
        <div className="payment-start-form">
          <div className="top">
            <div className="title">Product Description</div>
            <input
              className="type-name"
              type="text"
              placeholder="Enter product description"
              value={`${type} Certification`}
              readOnly
            />
          </div>
          <div className="payment-start-check">
            <div className="pay-amount">
              <h4>Payment Amount</h4>
              <h5>
                {(isGetting )
                  ? "......"
                  : formattedAmount
                    ? `\u20A6${addCommas(formattedAmount)}`
                    : "Nil"}
              </h5>
            </div>
          </div>
          <form
            name="form1"
            id="form1"
            action={paymentUrl}
            method="post"
            className="form"
          >
            <input
              type="hidden"
              name="merchant_id"
              id="merchant_id"
              value={merchantId}
              readOnly="readonly"
            />
            <input
              type="hidden"
              name="secretkey"
              id="secretkey"
              value={secretKey}
              readOnly="readonly"
            />
            <input
              type="hidden"
              name="product_id"
              id="product_id"
              value={productId}
            />
            <input
              type="hidden"
              name="product_description"
              id="product_description"
              value={productDesc}
            />
            <input type="hidden" name="amount" id="amount" value={amount} />
            <input
              type="hidden"
              name="currency"
              id="currency"
              value={currency}
            />
            <input
              type="hidden"
              name="transaction_id"
              id="transaction_id"
              value={transactionId}
            />
            <input
              type="hidden"
              name="response_url"
              id="response_url"
              value={responseUrl}
            />
            <input
              type="hidden"
              name="payment_type"
              id="payment_type"
              value={paymentType}
            />
            <input type="hidden" name="hash" id="hash" value={hash} />
            <div style={{ display: "block", width: "100%", }}>
              <Button3
                width="100%"
                height="58px"
                word={"MAKE PAYMENT WITH CENTRALPAY"}
                disabled={isGetting || validate || true}
                onClick={() => setPaymentType("cpay-card-payment")}
                type="submit"
              />
              <Button4
                width="100%"
                height="58px"
                word={"MAKE PAYMENT WITH BANK TRANSFER"}
                disabled={isGetting || validate}
                onClick={() => handlePaymentWithBankTransfer()}
                type="button"
              >
                MAKE PAYMENT WITH BANK TRANSFER
              </Button4>
            </div>

          </form>
        </div>
      </div>
    </div>
  );
};
const mapDispatchToProps = (dispatch) => ({
  getDetails: (payload) => dispatch(getCertPaymentDetails(payload)),
});
const mapStateToProps = (state) => {
  return {
    isGetting: state.test.isGettingCertDetails,
    details: state.test.certDetailPaymentDetails,
    success: state.test.certDetailsSuccess,
    certificationAmountByAppId: state.docs.certificationAmountByAppId,
    certificationAmount: state.docs.certificationAmount

  };
};
Payment.propTypes = {
  details: PropTypes.object,
  getDetails: PropTypes.func,
  isGetting: PropTypes.bool,
  location: PropTypes.shape({
    state: PropTypes.shape({
      id: PropTypes.number,
      type: PropTypes.string,
    }),
  }),
};
export default connect(mapStateToProps, mapDispatchToProps)(Payment);